export default __webpack_public_path__ + "static/media/email-share.51a90419.svg";